/**
 * Which environment this copy of The Sweet Spot is running in, worked out at runtime
 * from the browser hostname. The same bundle can be deployed to more than one
 * environment, so a build-time flag cannot be trusted.
 *
 *   dev    dev.sweetspot.ampersandbrands.com, localhost, 127.x   -> red bubble
 *   stage  stage.sweetspot.ampersandbrands.com                   -> yellow bubble
 *   prod   everything else (sweetspot.ampersandbrands.com)       -> no bubble
 *
 * `index.html` repeats this rule in a tiny inline script so the favicon is
 * swapped before the app loads. Keep the two in step.
 */

export type AppEnv = 'dev' | 'stage' | 'prod';

export function appEnvForHostname(hostname: string): AppEnv {
  const h = hostname.toLowerCase();
  if (h.indexOf('stage.') === 0 || h.indexOf('.stage.') !== -1) return 'stage';
  if (h.indexOf('dev.') === 0 || h.indexOf('.dev.') !== -1) return 'dev';
  if (h === 'localhost' || h.endsWith('.localhost') || h.indexOf('127.') === 0) return 'dev';
  return 'prod';
}

/** The environment of the page being viewed. Prod when there is no window (tests, SSR). */
export function currentAppEnv(): AppEnv {
  return typeof window === 'undefined' ? 'prod' : appEnvForHostname(window.location.hostname);
}

/** The bubble colour: red for dev, yellow for stage, none for prod. */
export const ENV_BADGE_COLOR: Record<Exclude<AppEnv, 'prod'>, string> = {
  dev: '#E5383B',
  stage: '#F2B705',
};

/** Tab-title prefix: "DEV · ", "STAGE · ", or nothing on prod. */
export function envTitlePrefix(env: AppEnv): string {
  return env === 'dev' ? 'DEV · ' : env === 'stage' ? 'STAGE · ' : '';
}
